import { render, staticRenderFns } from "./Baixas.vue?vue&type=template&id=6a60ffe3&scoped=true&"
import script from "./Baixas.vue?vue&type=script&lang=js&"
export * from "./Baixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60ffe3",
  null
  
)

export default component.exports